import React from "react"
import styled from "styled-components"
import { Container } from "../styles/Container"
import { breakpoint } from "../layout/styles"
import ReactHtmlParser from 'react-html-parser'
import Image from "next/image"
import Link from "next/link"

/**
 * LogoGrid Component
 * 
 * A responsive grid of logos with an optional heading and content.
 * 
 * Props:
 * - data: Contains the heading, content, and an array of logo objects.
 *   - heading: A string for the section title.
 *   - content: Additional content or description. This can contain HTML, which will be parsed.
 *   - logos: An array of logo objects. Each logo object contains:
 *     - _metadata.uid: A unique identifier for the logo.
 *     - link.href: URL to which the logo should link.
 *     - image.url: The source URL of the logo image.
 *     - image.title: The alt text for the logo image.
 */
const LogoGrid = ({ data }) => {
  return (
    <Wrapper>
      {data.heading && <h2>
        {data.heading}
      </h2>}
      {data.content && <Body>
        {ReactHtmlParser(data.content)}
      </Body>}
      <Grid>
        {data.logos?.map((logo) => (
          <Link key={logo._metadata.uid} href={logo.link.href} passHref>
            <a href="" target="_blank" rel="noopener noreferrer">
              <Image
                src={logo.image.url}
                width={135}
                height={96}
                alt={logo.image.title} />
            </a>
          </Link>
        ))}
      </Grid>
    </Wrapper>
  )
}

export default LogoGrid

const Wrapper = styled(Container)`
  margin: 36px 20px;
  @media ${breakpoint.desktop} {
    margin: 72px auto;
  }
`

const Body = styled.div<any>`
  margin-bottom: 36px;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  text-align: center;

  @media ${breakpoint.tablet} {
    grid-template-columns: repeat(5, 1fr);
  }
`
